import { createTheme } from "@mui/material/styles";

const white = "#ffffff";
const btbBlue = "#001f45";
const primaryBlue = "#3963a3";
const grey = "#f3f3ee";
const yellow = "#f5d143";

const correctGreen = "#4caf50";
const wrongRed = "#f44336";

export const theme = createTheme({
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  components: {
    // make tooltips bigger
    MuiTooltip: {
      defaultProps: {
        componentsProps: {
          tooltip: {
            style: {
              fontSize: 20,
            },
          },
        },
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: "h2",
          h2: "h2",
          h3: "h2",
          h4: "h2",
          h5: "h2",
          h6: "h2",
          subtitle1: "h2",
          subtitle2: "h2",
          body1: "span",
          body2: "span",
        },
      },
    },
  },
  palette: {
    text: {
      main: btbBlue,
    },
    background: {
      main: white,
    },
    primary: {
      main: primaryBlue,
      contrastText: white,
    },
    secondary: {
      main: grey,
      contrastText: btbBlue,
    },
    accent: {
      main: yellow,
      contrastText: btbBlue,
    },
    // error: {
    //   main: yellow,
    //   contrastText: btbBlue,
    // },
    correct: {
      main: correctGreen,
      contrastText: white,
    },
    wrong: {
      main: wrongRed,
      contrastText: white,
    },
    finishCards: {
      github: {
        main: "#24292e",
        contrastText: white,
      },
      udemy: {
        main: "#a435f0",
        contrastText: white,
      },
      isFox: {
        main: "#f29400",
        contrastText: white,
      },
      essensgutscheine: {
        main: btbBlue,
        contrastText: white,
      },
      sicherheitsunterweisung: {
        main: btbBlue,
        contrastText: white,
      },
      sekretariat: {
        main: btbBlue,
        contrastText: white,
      },
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& input": {
            color: btbBlue,
          },
          "&$error": {
            "& fieldset": {
              borderColor: yellow,
            },
            "& input,& p, & label ": {
              color: btbBlue,
            },
          },
        },
      },
    },
  },
});
